export default "__VITE_ASSET__qs0wCEMs__"